import React, { useMemo } from 'react';
import { Journey } from 'src/common/interfaces/journey.interface';
import { DashboardInsightsJourneysTabType } from '../constants';
import { DashboardInsightsJourneysJourneyVisitorVisitorsTable } from './visitors-table';
import { Node } from 'src/common/interfaces/node.interface';
import { DashboardInsightsJourneysJourneyVisitorStepsTable } from './steps-table';
import { DashboardInsightsJourneysJourneyVisitorTabs } from './tabs';

type DashboardInsightsJourneysJourneyVisitorContentProps = {
  activeTabType: DashboardInsightsJourneysTabType;
  journey: Journey;
  sessionUuid: string;
};

export const DashboardInsightsJourneysJourneyVisitorContent = ({
  activeTabType,
  journey,
  sessionUuid,
}: DashboardInsightsJourneysJourneyVisitorContentProps) => {
  const contentList: Node[] = useMemo(() => journey.steps.flatMap((step) => step.nodes), [journey]);

  return (
    <>
      <div className='flex space-x-md divide-x divide-bedrock-gray-medium'>
        <DashboardInsightsJourneysJourneyVisitorTabs
          activeTab={activeTabType}
          journeyUuid={journey.uuid}
          sessionUuid={sessionUuid}
        />
      </div>
      <div className='grow flex flex-col mt-6 w-full'>
        {activeTabType === 'steps' ? (
          <DashboardInsightsJourneysJourneyVisitorStepsTable
            contentList={contentList}
            journey={journey}
            sessionUuid={sessionUuid}
          />
        ) : activeTabType === 'visitor-sessions' ? (
          <DashboardInsightsJourneysJourneyVisitorVisitorsTable
            journey={journey}
            contentList={contentList}
            sessionUuid={sessionUuid}
          />
        ) : null}
      </div>
    </>
  );
};
